import React, { useCallback, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';
import ListPage from '@components/common/layout/ListPage';
import KitplaySettingSavePage from '@components/common/page/kitplaySetting/KitplaySettingSavePage';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { getData, setData } from '@utils/localStorage';
import { Button, Modal, Tabs } from 'antd';

import Device from './tabs/Device';
import GroupArea from './tabs/GroupArea';
import GroupDevice from './tabs/GroupDevice';

import styles from './index.module.scss';


const KitplayDeviceTabPage = ({ tabKey, restaurantId, restaurant, serverDetail, savedFilter, onFilterChange }) => {
    const translate = useTranslate();
    const location = useLocation();
    const navigate = useNavigate();
    const groupDeviceRef = useRef(null);
   
   
    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = getData(routes.deviceTabsRestaurantListPage.keyActiveTab + tabKey);
        return savedTab || 'device';
    });
    const [groupDeviceDirty, setGroupDeviceDirty] = useState(false);
   
    const confirmIfDirty = useCallback((action, contentMessage) => {
        if (groupDeviceDirty) {
            Modal.confirm({
                title: translate.formatMessage(commonMessage.unsavedChangesContent),
                content: contentMessage || '',
                okText: translate.formatMessage(commonMessage.continue),
                cancelText: translate.formatMessage(commonMessage.cancel),
                centered: true,
                onOk: () => {
                    setGroupDeviceDirty(false);
                    action();
                },
            });
        } else {
            action();
        }
    }, [groupDeviceDirty]);
   
    const handleCreateClick = () => {
        confirmIfDirty(() => doCreateNavigation());
    };
   
    const doCreateNavigation = () => {
        const deviceId = serverDetail?.id;
        const currentPath = location.pathname;
        const searchParams = location.search;

        if (activeTab === 'device' || activeTab === 'group-device') {
            const createLink = `${currentPath}/kitplay/group-device/create${searchParams}${searchParams ? '&' : '?'}deviceId=${deviceId}`;
            navigate(createLink);
        } else if (activeTab === 'area') {
            const createLink = `${currentPath}/kitplay/area/create${searchParams}${searchParams ? '&' : '?'}deviceId=${deviceId}`;
            navigate(createLink);
        }
    };

    return (
        <ListPage
            baseTable={
                <>
                    {/* <div className={styles.btn}>
                        {activeTab !== 'setting-device' && activeTab !== 'mysql' && activeTab !== 'group-device' && (
                            <Button
                                type="primary"
                                style={{ width: '120px', height: '32px' }}
                                onClick={handleCreateClick}
                            >
                                <PlusOutlined /> <FormattedMessage defaultMessage="Add new" />
                            </Button>
                        )}

                        {activeTab === 'group-device' && (
                            <>
                                <Button
                                    type="primary"
                                    style={{ height: '32px', marginRight:'16px' }}
                                    onClick={() => groupDeviceRef.current?.openCreateModal()}
                                >
                                    <PlusOutlined /> <FormattedMessage defaultMessage="Add" />
                                </Button>
                                <Button
                                    type="primary"
                                    style={{ height: '32px' }}
                                    disabled={!groupDeviceDirty}
                                    onClick={() => groupDeviceRef.current?.handleSave()}
                                >
                                    <SaveOutlined /> <FormattedMessage defaultMessage="Save" />
                                </Button>
                            </>
                        )}
                    </div> */}
                    <Tabs
                        type="card"
                        destroyInactiveTabPane
                        onTabClick={(key) => {
                            if (key === activeTab) return;
                            confirmIfDirty(() => {
                                setActiveTab(key);
                                setData(routes.deviceTabsRestaurantListPage.keyActiveTab + tabKey, key);
                            }, translate.formatMessage(commonMessage.unsavedSwitchTab));
                        }}
                        activeKey={activeTab}
                        items={[
                            {
                                key: 'area',
                                label: translate.formatMessage(commonMessage.area),
                                children: <GroupArea serverDetail={serverDetail}/>,
                            },
                            {
                                key: 'device',
                                label: translate.formatMessage(commonMessage.childDevice),
                                children: <Device serverDetail={serverDetail}/>,
                            },
                            {
                                key: 'group-device',
                                label: translate.formatMessage(commonMessage.workflow),
                                children: (
                                    <GroupDevice ref={groupDeviceRef} onDirtyChange={setGroupDeviceDirty} serverDetail={serverDetail}/>
                                ),
                            },
                            {
                                key: 'setting-device',
                                label: translate.formatMessage(commonMessage.setting),
                                children: <KitplaySettingSavePage deviceId={serverDetail?.id}/>,
                            },
                        ]}
                    />
                </>
            }
        />
    );
};

export default KitplayDeviceTabPage;
